export default "__VITE_ASSET__D7FR5b04__"